<template>
    <div>
        <div v-if="isIos || isAndroid">
            <UpgradeDevice></UpgradeDevice>
        </div>
        <div v-else>
            <UpgradeComp></UpgradeComp>
        </div>
    </div>
</template>

<script>
import Upgrade from "@/components/Upgrade.vue";
import UpgradeDevice from "@/components/UpgradeDevice.vue";
import { device } from "@/mixins/device";

export default {
    name: "upgrade",
    mixins: [device],
    data: function() {
        return {
            //
        };
    },
    mounted: function() {},
    computed: {
        // isIos: function() {
        //     if (device && device.platform) {
        //         return device.platform == "iOS" || device.platform == "Android";
        //     }
        //     return false;
        // }
    },
    created: function() {
        //
    },
    components: {
        UpgradeComp: Upgrade,
        UpgradeDevice
    }
};
</script>
